"use strict";
'use es6'; // Scopes

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiMap = exports.WEBSITE_PAGES_ACCESS_SCOPE = exports.LANDING_PAGES_ACCESS_SCOPE = exports.BLOG_ACCESS_SCOPE = exports.KNOWLEDGE_ACCESS_SCOPE = exports.CONTENT_ACCESS_SCOPE = void 0;
var CONTENT_ACCESS_SCOPE = 'content-access';
exports.CONTENT_ACCESS_SCOPE = CONTENT_ACCESS_SCOPE;
var KNOWLEDGE_ACCESS_SCOPE = 'service-knowledge-access';
exports.KNOWLEDGE_ACCESS_SCOPE = KNOWLEDGE_ACCESS_SCOPE;
var BLOG_ACCESS_SCOPE = 'blog-access';
exports.BLOG_ACCESS_SCOPE = BLOG_ACCESS_SCOPE;
var LANDING_PAGES_ACCESS_SCOPE = 'landingpages-access';
exports.LANDING_PAGES_ACCESS_SCOPE = LANDING_PAGES_ACCESS_SCOPE;
var WEBSITE_PAGES_ACCESS_SCOPE = 'sitepages-access'; // Api proxy definitions

exports.WEBSITE_PAGES_ACCESS_SCOPE = WEBSITE_PAGES_ACCESS_SCOPE;
var ApiMap = {
  BLOGS: {
    getUrl: function getUrl() {
      return "blog-settings/v1/blogs";
    },
    regex: new RegExp('^blog-settings/v1/blogs$'),
    methods: ['GET']
  },
  CTAS: {
    getUrl: function getUrl(guid) {
      return "ctas/v3/placements/" + guid;
    },
    regex: new RegExp('^ctas/v3/placements/[^/]+'),
    methods: ['GET']
  },
  FILE_INFO: {
    getUrl: function getUrl(filePath) {
      return "filemanager/api/v2/files/info/" + filePath;
    },
    regex: new RegExp('^filemanager/api/v2/files/info/.*'),
    methods: ['GET']
  },
  FORMS: {
    getUrl: function getUrl(guid) {
      return "forms/v2/forms/" + guid;
    },
    regex: new RegExp('^forms/v2/forms/[^/]+'),
    methods: ['GET']
  },
  MEETINGS: {
    getUrl: function getUrl() {
      return "meetings/v1/link/portal";
    },
    regex: new RegExp('^meetings/v1/link/portal$'),
    methods: ['GET']
  },
  MEETINGS_SEARCH: {
    getUrl: function getUrl(slug) {
      return "meetings/v1/link/slug/" + slug;
    },
    regex: new RegExp('^meetings/v1/link/slug/[^/]+'),
    methods: ['GET']
  },
  PAGES_CONTENT: {
    getUrl: function getUrl() {
      return "content/api/v4/contents";
    },
    regex: new RegExp('^content/api/v4/contents$'),
    methods: ['GET']
  },
  PAGES_SEARCH: {
    getUrl: function getUrl() {
      return "contentsearch/v2/search/internal";
    },
    regex: new RegExp('^contentsearch/v2/search/internal$'),
    methods: ['GET']
  },
  USERS: {
    getUrl: function getUrl() {
      return "users/v2/app/hub-users";
    },
    regex: new RegExp('^users/v2/app/hub-users$'),
    methods: ['GET']
  },
  USER_SETTINGS: {
    getUrl: function getUrl() {
      return "users/v1/app/attributes";
    },
    regex: new RegExp('^users/v1/app/attributes'),
    methods: ['GET', 'POST']
  },
  VIDEO_PLAYER: {
    getUrl: function getUrl(playerId) {
      return "filemanager/api/v3/players/" + playerId;
    },
    regex: new RegExp('^filemanager/api/v3/players/[^/]+'),
    methods: ['GET']
  },
  PROPERTIES: {
    getUrl: function getUrl(category) {
      return "properties/v2/" + category + "/properties";
    },
    regex: new RegExp('^properties/v2/[^/]+/properties'),
    methods: ['GET']
  },
  OWNERS: {
    getUrl: function getUrl() {
      return "owners/v2/owners";
    },
    regex: new RegExp('^owners/v2/owners$'),
    methods: ['GET']
  },
  SITE_SETTINGS: {
    getUrl: function getUrl(portalId) {
      return "content-settings/v1/site-settings/by-portal-id/" + portalId;
    },
    regex: new RegExp('^content-settings/v1/site-settings/by-portal-id/[^/]+'),
    methods: ['GET']
  }
};
exports.ApiMap = ApiMap;